var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.allApplicants, function (applicant, applicantIndex) {
        return _c(
          "div",
          {
            key:
              _vm.applicantNameFromIndex(applicantIndex) + "-" + applicantIndex,
          },
          [
            _vm.isApplicantVisibleFromFillOut(applicant.id)
              ? _c(
                  "page-summary-section-group-layout",
                  { attrs: { "show-divider": "" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex justify-content-between mb-4",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "section-title",
                              { attrs: { "title-type": "subtitle" } },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.applicantNameFromIndex(
                                          applicantIndex
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link text-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddOtherProperty(
                                      applicantIndex,
                                      applicant.id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            + " +
                                    _vm._s(
                                      _vm.addPropertyButtonText(applicant)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.applicantHasOtherProperties(
                      applicant["other-properties"]
                    )
                      ? _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c("h6", { staticClass: "text-light-gray" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      applicantIndex
                                        ? _vm.$t(
                                            "application-standalone.pages.properties.applicantHasNoProperties"
                                          )
                                        : _vm.$t(
                                            "application-standalone.pages.properties.youHaveNoProperties"
                                          )
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._l(
                          applicant["other-properties"],
                          function (otherProperty, otherPropertyIndex) {
                            return _c(
                              "b-row",
                              {
                                key:
                                  "property-" +
                                  applicant.id +
                                  "-" +
                                  otherPropertyIndex,
                                staticClass: "mb-5",
                              },
                              [
                                _c("b-col", [
                                  _c(
                                    "h6",
                                    {
                                      class: {
                                        "text-light-gray":
                                          !_vm.otherPropertySummarySubtitle(
                                            otherProperty
                                          ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.otherPropertySummarySubtitle(
                                              otherProperty
                                            ) ||
                                              _vm.$t(
                                                "application-standalone.pages.pleaseReviewThisSection"
                                              )
                                          ) +
                                          "\n            "
                                      ),
                                      _vm.isInvalid(
                                        applicantIndex,
                                        otherPropertyIndex
                                      )
                                        ? _c("application-section-error-icon", {
                                            attrs: {
                                              id:
                                                "error-tooltip-" +
                                                applicantIndex +
                                                "-" +
                                                otherPropertyIndex,
                                              "show-errors": _vm.showErrors,
                                              "is-first-item":
                                                applicantIndex ===
                                                  _vm.firstErrorId
                                                    .applicantIndex &&
                                                otherPropertyIndex ===
                                                  _vm.firstErrorId
                                                    .otherPropertyIndex,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { cols: "auto" } }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-danger mr-1 my-lg-0 my-3",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDeletionModal({
                                            applicantIndex: applicantIndex,
                                            otherPropertyIndex:
                                              otherPropertyIndex,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("global.words.delete")
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary text-capitalize skip-disable-all-inputs",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleNavigation(
                                            applicantIndex,
                                            otherPropertyIndex,
                                            applicant.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.allowEdit
                                        ? _c("icon", {
                                            staticClass: "text-primary mr-1",
                                            attrs: { name: "pencil" },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.editButtonText) +
                                          "\n          "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            )
                          }
                        ),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("remove-component-modal", {
        ref: "removeComponentModal",
        attrs: { text: _vm.modalText },
        on: { accept: _vm.handleDelete },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }